import React from 'react';
import { API_BASE_URL } from '../services/apiServices';

export default function ProductCard({
  item,
  currency,
  onAddItem,
  design = 'list',
}) {
  const imageUrl = item.image
    ? `${API_BASE_URL}/${item.image}`
    : null;

  const price = item.hasSizes
    ? `From ${currency} ${item.sizes?.[0]?.price ?? 0}`
    : `${currency} ${item.price}`;

  const addButton = (
    <button
      onClick={() => onAddItem(item)}
      style={addBtnStyle}
    >
      + Add
    </button>
  );

  // -------------------------
  // GRID 3
  // -------------------------
  if (design === 'grid3') {
    return (
      <div style={gridCardStyle}>
        {imageUrl && (
          <img
            src={imageUrl}
            alt={item.name}
            style={gridImageStyle}
          />
        )}

        <div style={gridContentStyle}>
          <h4 style={titleStyle}>{item.name}</h4>

          {item.description && (
            <p style={descriptionStyle}>
              {item.description}
            </p>
          )}

          <div style={bottomStyle}>
            <span style={priceStyle}>{price}</span>
            {addButton}
          </div>
        </div>
      </div>
    );
  }

  // -------------------------
  // GRID 2
  // -------------------------
  if (design === 'grid2') {
    return (
      <div style={gridCardStyle}>
        {imageUrl && (
          <img
            src={imageUrl}
            alt={item.name}
            style={gridImageStyle}
          />
        )}

        <div style={gridContentStyle}>
          <h4 style={titleStyle}>{item.name}</h4>

          {item.description && (
            <p style={descriptionStyle}>
              {item.description}
            </p>
          )}

          <div style={bottomStyle}>
            <span style={priceStyle}>{price}</span>
            {addButton}
          </div>
        </div>
      </div>
    );
  }

  // -------------------------
  // COMPACT
  // -------------------------
  if (design === 'compact') {
    return (
      <div style={compactCardStyle}>
        {imageUrl && (
          <img
            src={imageUrl}
            alt={item.name}
            style={compactImageStyle}
          />
        )}

        <div style={{ flex: 1 }}>
          <h4 style={titleStyle}>{item.name}</h4>

          <div style={compactBottomStyle}>
            <span style={priceStyle}>{price}</span>
            {addButton}
          </div>
        </div>
      </div>
    );
  }

  // -------------------------
  // IMAGE TOP
  // -------------------------
  if (design === 'imageTop') {
    return (
      <div style={imageTopCardStyle}>
        {imageUrl && (
          <img
            src={imageUrl}
            alt={item.name}
            style={imageTopStyle}
          />
        )}

        <div style={{ padding: '0.75rem' }}>
          <h4 style={titleStyle}>{item.name}</h4>

          {item.description && (
            <p style={descriptionStyle}>
              {item.description}
            </p>
          )}

          <div style={bottomStyle}>
            <span style={priceStyle}>{price}</span>
            {addButton}
          </div>
        </div>
      </div>
    );
  }

  // -------------------------
  // MINIMAL
  // -------------------------
  if (design === 'minimal') {
    return (
      <div style={minimalCardStyle}>
        <div style={{ flex: 1 }}>
          <h4 style={titleStyle}>{item.name}</h4>

          {item.description && (
            <p style={descriptionStyle}>
              {item.description}
            </p>
          )}
        </div>

        <div style={minimalRightStyle}>
          <span style={priceStyle}>{price}</span>
          {addButton}
        </div>
      </div>
    );
  }

  // -------------------------
  // DEFAULT: LIST
  // -------------------------
  return (
    <div style={foodCardStyle}>
      {imageUrl && (
        <img
          src={imageUrl}
          alt={item.name}
          style={foodImageStyle}
        />
      )}

      <div style={{ flex: 1, paddingLeft: '0.75rem' }}>
        <h4 style={titleStyle}>{item.name}</h4>

        {item.description && (
          <p style={descriptionStyle}>
            {item.description}
          </p>
        )}

        <div style={bottomStyle}>
          <span style={priceStyle}>{price}</span>
          {addButton}
        </div>
      </div>
    </div>
  );
}


// ======================================================
// STYLES
// ======================================================

const foodCardStyle = {
  display: 'flex',
  background: '#FFF',
  borderRadius: '12px',
  padding: '0.75rem',
  marginBottom: '0.75rem',
  boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
};

const foodImageStyle = {
  width: '85px',
  height: '85px',
  borderRadius: '8px',
  objectFit: 'cover',
};

const gridCardStyle = {
  background: '#FFF',
  borderRadius: '12px',
  overflow: 'hidden',
  boxShadow: '0 1px 4px rgba(0,0,0,0.08)',
  display: 'flex',
  flexDirection: 'column',
};

const gridImageStyle = {
  width: '100%',
  height: '150px',
  objectFit: 'cover',
};

const gridContentStyle = {
  padding: '0.7rem',
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
};

const compactCardStyle = {
  display: 'flex',
  alignItems: 'center',
  background: '#FFF',
  borderRadius: '10px',
  padding: '0.5rem',
  marginBottom: '0.5rem',
  boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
};

const compactImageStyle = {
  width: '60px',
  height: '60px',
  borderRadius: '8px',
  objectFit: 'cover',
  marginRight: '0.65rem',
};

const imageTopCardStyle = {
  background: '#FFF',
  borderRadius: '14px',
  overflow: 'hidden',
  boxShadow: '0 2px 6px rgba(0,0,0,0.08)',
};

const imageTopStyle = {
  width: '100%',
  height: '200px',
  objectFit: 'cover',
};

const minimalCardStyle = {
  display: 'flex',
  alignItems: 'center',
  background: '#FFF',
  borderBottom: '1px solid #E5E7EB',
  padding: '0.75rem 0',
};

const minimalRightStyle = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-end',
  gap: '0.4rem',
};

const titleStyle = {
  margin: '0 0 0.25rem 0',
  fontSize: '1rem',
  color: '#111827',
};

const descriptionStyle = {
  margin: '0 0 0.5rem 0',
  fontSize: '0.8rem',
  color: '#6B7280',
  lineHeight: '1.2',
};

const bottomStyle = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: '0.5rem',
  marginTop: 'auto',
};

const compactBottomStyle = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: '0.4rem',
};

const priceStyle = {
  fontWeight: 'bold',
  color: '#10B981',
  fontSize: '0.9rem',
};

const addBtnStyle = {
  background: '#10B981',
  color: '#FFF',
  border: 'none',
  padding: '0.35rem 0.85rem',
  borderRadius: '6px',
  fontWeight: '600',
  cursor: 'pointer',
};
 